import { I18n } from '@calendly/i18n'
import moment from 'moment-timezone'

import { loadLocale, momentLocaleFor } from 'services/load_locale'

export default async (locale, ...additionalLocales) => {
  await loadLocale(locale, ...additionalLocales)
  I18n.locale = locale
  moment.locale(momentLocaleFor(locale))
}
